<h2 mat-dialog-title>LiqPay для {{ data.invoiceTitle }}</h2>

<mat-dialog-content class="payment-link-dialog">
  <div class="summary">
    <span>Доступно</span>
    <strong>{{ supportService.formatMoney(availableAmount) }}</strong>
    <span *ngIf="activeReservedAmount > 0">
      В активных ссылках: {{ supportService.formatMoney(activeReservedAmount) }}
    </span>
  </div>

  <form [formGroup]="form" class="payment-link-form">
    <mat-form-field appearance="outline">
      <mat-label>Сумма</mat-label>
      <input matInput type="number" min="0.01" step="0.01" [formControl]="amountControl" />
      <mat-error *ngIf="amountControl.invalid">Введите сумму больше 0</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Описание</mat-label>
      <input matInput [formControl]="descriptionControl" />
    </mat-form-field>
  </form>

  <mat-form-field appearance="outline" class="result-field" *ngIf="generatedLink?.url">
    <mat-label>Ссылка</mat-label>
    <input matInput readonly [value]="generatedLink?.url" />
    <button mat-icon-button matSuffix type="button" (click)="copy(generatedLink?.url)">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-form-field>

  <div class="links" *ngIf="links.length">
    <div class="links-header">
      <div class="links-title">Последние ссылки</div>
      <button
        mat-icon-button
        type="button"
        (click)="loadLinks()"
        [disabled]="loading"
        matTooltip="Обновить статусы"
      >
        <mat-icon>{{ loading ? 'hourglass_empty' : 'refresh' }}</mat-icon>
      </button>
    </div>
    <div class="link-row" *ngFor="let link of links">
      <div class="link-info">
        <strong>{{ supportService.formatMoney(link.amount) }}</strong>
        <span class="status-badge" [ngClass]="getStatusClass(link.status)">
          {{ getStatusLabel(link.status) }}
        </span>
        <span
          *ngIf="
            link.fiscalization_status &&
            (link.status === 'PAID' || link.fiscalization_status !== 'NOT_ATTEMPTED')
          "
          class="status-badge"
          [ngClass]="getFiscalizationStatusClass(link.fiscalization_status)"
        >
          {{ getFiscalizationStatusLabel(link.fiscalization_status) }}
        </span>
        <span
          class="fiscalization-error"
          *ngIf="
            link.fiscalization_error &&
            (link.fiscalization_status === 'FAILED' || link.status === 'FAILED')
          "
        >
          {{ link.fiscalization_error }}
        </span>
      </div>
      <div class="link-actions">
        <button mat-icon-button type="button" (click)="copy(link.url)" [matTooltip]="link.url">
          <mat-icon>content_copy</mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          color="warn"
          class="delete-link-button"
          *ngIf="canDelete(link)"
          (click)="deleteLink(link)"
          [disabled]="deletingById[link.id]"
          matTooltip="Удалить ссылку"
        >
          <mat-icon>{{ deletingById[link.id] ? 'hourglass_empty' : 'delete' }}</mat-icon>
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Закрыть</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="submit()"
    [disabled]="submitting || loading || form.invalid || availableAmount <= 0"
  >
    <mat-icon>link</mat-icon>
    Создать
  </button>
</mat-dialog-actions>
